module.exports = __webpack_public_path__ + "assets/img/head_title.8bc97432.png";